import React, { useEffect, useState } from "react";
import "./index.css";
import { useMediaQuery } from "@mui/material";
import SideNav from "../SideNav";
import Header from "../Header";
import { Outlet } from "react-router-dom";
import io from "socket.io-client";
import CustomDialog from "../../Molecules/CustomDialog";
import ReminderModal from "./ReminderModal";
import ConfirmModal from "../../Molecules/ConfirmModal/Index";
import { useSelector } from "react-redux";
import { isSuperAdmin } from "../../../Utils/getters";

let socket;

const Layout = (props) => {
  const [sidenav, setSidenav] = useState(true);
  const [mobilenav, setMobilenav] = useState(false);

  const isMatches = useMediaQuery("(max-width:991px)");

  const nav = isMatches ? mobilenav : sidenav;

  const handleDrawerOpen = () =>
    isMatches ? setMobilenav(true) : setSidenav(true);

  const handleDrawerClose = () =>
    isMatches ? setMobilenav(false) : setSidenav(false);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [reminderData, setReminderData] = useState([]);
  const [AMCreminderData, setAMCReminderData] = useState();

  const [openAMCReminder, setOpenAMCReminder] = useState(false);
  const handleOpenAMCReminder = () => setOpenAMCReminder(true);
  const handleCloseAMCReminder = () => setOpenAMCReminder(false);

  const { getUserResponse } = useSelector((state) => state.user);

  useEffect(() => {
    if (!socket) {
      const TOKEN = localStorage.getItem("token");
      const BASE_URL = process.env.REACT_APP_BACKEND_ROUTE;
      socket = io(BASE_URL, {
        auth: {
          token: `Bearer ${TOKEN}`,
        },
      });
      socket.on("connect", () => {});
    }

    socket.on("reminder_interval", (data) => {
      if (getUserResponse?.data && data.length > 0) {
        const filtered_data = isSuperAdmin(getUserResponse?.data)
          ? data
          : data?.filter(
              (e) =>
                e?.visitor_log_ref?.created_by === getUserResponse?.data?._id
            );
        setReminderData(filtered_data);
        handleOpen();
      }
    });

    return () => {
      socket.off("reminder_received");
    };
  }, [getUserResponse]);

  const { getSingleAMCResponse } = useSelector((state) => state.loginReducer);

  useEffect(() => {
    if (getSingleAMCResponse?.success) {
      setAMCReminderData(getSingleAMCResponse?.data);
      handleOpenAMCReminder();
    }
  }, [getSingleAMCResponse]);

  return (
    <>
      <CustomDialog
        maxWidth="sm"
        title={`AMC - REMINDER`}
        handleClose={handleCloseAMCReminder}
        open={openAMCReminder}
      >
        <ConfirmModal
          message={AMCreminderData?.title}
          subMessage={AMCreminderData?.message}
          button_label="Okay"
          icon_type="DONE"
          handleSubmit={handleCloseAMCReminder}
        />
      </CustomDialog>
      <CustomDialog
        maxWidth="md"
        position="bottom-right"
        title={"VISITOR / CONTRACTOR PASS"}
        handleClose={() => {
          handleClose();
        }}
        open={open}
      >
        <ReminderModal data={reminderData} handleClose={handleClose} />
      </CustomDialog>
      <div className="layoutWrapper">
        {props.hideLayout ? (
          <>
            <div className="sideBarWrapper"></div>
            <div className="viewPortWrapper overflow-auto">
              <div className="pageViewPort">{props.children}</div>
            </div>
          </>
        ) : (
          <>
            <div className="sideBarWrapper">
              <SideNav
                handleDrawerOpen={handleDrawerOpen}
                handleDrawerClose={handleDrawerClose}
                nav={nav}
              />
            </div>
            <div className="viewPortWrapper overflow-auto">
              <div className="hdrWrapr">
                <Header
                  handleDrawerOpen={handleDrawerOpen}
                  handleDrawerClose={handleDrawerClose}
                  nav={nav}
                />
              </div>
              <div className="pageViewPort">
                <Outlet />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Layout;
